import React, { useRef, useEffect } from "react";

const HandlePopupWindow = (ref, theSet) => {
    useEffect(() => {
        // Detect clicking on outside of element
        const handleClickOutside = (event) => {
            if (ref.current && !ref.current.contains(event.target)) {
                theSet(false);
            }
        };
        // Bind the event listener
        document.addEventListener("mousedown", handleClickOutside);
        return () => {
            // Unbind the event listener on clean up
            document.removeEventListener("mousedown", handleClickOutside);
        };
    }, [ref, theSet]);
};

const PopupWindow = (props) => {
    const wrapperRef = useRef(null);
    HandlePopupWindow(wrapperRef, props.theSet);

    return (
        <div className={props.className} ref={wrapperRef}>
            {props.children}
        </div>
    );
};

export default PopupWindow;